import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { customImageLoader } from '@restworld/utils-common';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Title from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerPerformanceTable(_ref) {
  var header = _ref.header,
      data = _ref.data;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(StatsTableWrapper, {
    children: [/*#__PURE__*/_jsxs(HeaderRowWrapper, {
      children: [/*#__PURE__*/_jsx(ColOneWrapper, {
        children: /*#__PURE__*/_jsx(CellHeaderContent, {
          children: t('platform')
        })
      }), /*#__PURE__*/_jsx(ColTwoWrapper, {
        children: header === null || header === void 0 ? void 0 : header.map(function (v) {
          return /*#__PURE__*/_jsx(InfoCell, {
            children: /*#__PURE__*/_jsx(CellHeaderContent, {
              children: v.label
            })
          }, v.key);
        })
      })]
    }), data.sort(function (a, b) {
      var _b$data, _a$data, _b$data2, _a$data2;

      var shortlistedDiff = (((_b$data = b.data) === null || _b$data === void 0 ? void 0 : _b$data.shortlisted) || 0) - (((_a$data = a.data) === null || _a$data === void 0 ? void 0 : _a$data.shortlisted) || 0);
      if (shortlistedDiff !== 0) return shortlistedDiff;
      return (((_b$data2 = b.data) === null || _b$data2 === void 0 ? void 0 : _b$data2.interested) || 0) - (((_a$data2 = a.data) === null || _a$data2 === void 0 ? void 0 : _a$data2.interested) || 0);
    }).map(function (item, i) {
      return /*#__PURE__*/_jsx(InfoRow, {
        platform: item,
        noBorder: i === Object.keys(data).length - 1,
        headerOrder: header.map(function (v) {
          return v.key;
        })
      }, item.label);
    })]
  });
}

function InfoRow(_ref2) {
  var platform = _ref2.platform,
      noBorder = _ref2.noBorder,
      headerOrder = _ref2.headerOrder;

  var _useTranslation2 = useTranslation('common'),
      translateCommon = _useTranslation2.t;

  var _ref3 = platform || {},
      logo = _ref3.logo,
      icon = _ref3.icon,
      data = _ref3.data,
      description = _ref3.description,
      label = _ref3.label;

  return /*#__PURE__*/_jsxs(InfoRowWrapper, {
    noBorder: noBorder,
    children: [/*#__PURE__*/_jsx(ColOneWrapper, {
      children: /*#__PURE__*/_jsxs(_StyledDiv, {
        children: [/*#__PURE__*/_jsxs(PlatformDetailsWrapper, {
          children: [logo && /*#__PURE__*/_jsx(LogoWrapper, {
            children: /*#__PURE__*/_jsx(_StyledImage, {
              src: logo,
              alt: "",
              fill: true,
              loader: customImageLoader
            })
          }), icon || /*#__PURE__*/_jsx(_StyledGlobeAltIcon, {}), /*#__PURE__*/_jsx(Title, {
            fontSize: "small",
            textColor: "neutral-200",
            fontWeight: "medium",
            children: label
          })]
        }), /*#__PURE__*/_jsx(Title, {
          fontSize: "small",
          textColor: "neutral-200",
          children: description
        })]
      })
    }), /*#__PURE__*/_jsx(_StyledColTwoWrapper, {
      children: data ? headerOrder.map(function (v) {
        return /*#__PURE__*/_jsxs(InfoCell, {
          children: [/*#__PURE__*/_jsx(_StyledCellHeaderContent, {
            children: translateCommon(v)
          }), /*#__PURE__*/_jsx(Statistic, {
            children: data === null || data === void 0 ? void 0 : data[v]
          })]
        }, v);
      }) : null
    })]
  });
}

export default EmployerPerformanceTable;
var StatsTableWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__StatsTableWrapper",
  componentId: "sc-1rtsphm-0"
})(["", ""], {
  "width": "100%",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))"
});
var InfoCell = /*#__PURE__*/styled.p.withConfig({
  displayName: "employer-performance-table__InfoCell",
  componentId: "sc-1rtsphm-1"
})(["", ""], {
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "@media (min-width: 640px)": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-end",
    "textAlign": "right"
  }
});
var Statistic = /*#__PURE__*/styled.span.withConfig({
  displayName: "employer-performance-table__Statistic",
  componentId: "sc-1rtsphm-2"
})(["", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});
var CellHeaderContent = /*#__PURE__*/styled.span.withConfig({
  displayName: "employer-performance-table__CellHeaderContent",
  componentId: "sc-1rtsphm-3"
})(["", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "600",
  "textTransform": "uppercase",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var _StyledCellHeaderContent = /*#__PURE__*/styled(CellHeaderContent).withConfig({
  displayName: "employer-performance-table___StyledCellHeaderContent",
  componentId: "sc-1rtsphm-4"
})({
  "@media (min-width: 640px)": {
    "display": "none"
  }
});

var ColOneWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__ColOneWrapper",
  componentId: "sc-1rtsphm-5"
})(["", ""], {
  "width": "100%"
});
var ColTwoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__ColTwoWrapper",
  componentId: "sc-1rtsphm-6"
})(["", ""], {
  "display": "flex",
  "width": "100%",
  "minWidth": "310px",
  "alignItems": "flex-start",
  "gap": "1rem"
});

var _StyledColTwoWrapper = /*#__PURE__*/styled(ColTwoWrapper).withConfig({
  displayName: "employer-performance-table___StyledColTwoWrapper",
  componentId: "sc-1rtsphm-7"
})({
  "marginTop": "1rem",
  "@media (min-width: 640px)": {
    "marginTop": "0px"
  }
});

var PlatformDetailsWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__PlatformDetailsWrapper",
  componentId: "sc-1rtsphm-8"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});
var HeaderRowWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__HeaderRowWrapper",
  componentId: "sc-1rtsphm-9"
})(["", ""], {
  "display": "none",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "padding": "1rem",
  "@media (min-width: 640px)": {
    "display": "flex"
  }
});
var InfoRowWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__InfoRowWrapper",
  componentId: "sc-1rtsphm-10"
})(["", " ", ""], {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "@media (min-width: 640px)": {
    "display": "flex"
  }
}, function (_ref4) {
  var noBorder = _ref4.noBorder;
  return noBorder ? {
    "borderStyle": "none"
  } : {
    "borderBottomWidth": "1px"
  };
});
var LogoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "employer-performance-table__LogoWrapper",
  componentId: "sc-1rtsphm-11"
})(["", ""], {
  "position": "relative",
  "display": "flex",
  "height": "2.25rem",
  "width": "2.25rem",
  "minWidth": "36px",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "0.25rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledDiv = /*#__PURE__*/styled("div").withConfig({
  displayName: "employer-performance-table___StyledDiv",
  componentId: "sc-1rtsphm-12"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "employer-performance-table___StyledImage",
  componentId: "sc-1rtsphm-13"
})({
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledGlobeAltIcon = /*#__PURE__*/styled(GlobeAltIcon).withConfig({
  displayName: "employer-performance-table___StyledGlobeAltIcon",
  componentId: "sc-1rtsphm-14"
})({
  "height": "1.25rem",
  "width": "1.25rem"
});